import { get } from "lodash";
import { useRecoilValue } from "recoil";
import { CompanyDetails } from "../recoil/LoggedInUserDetail/selector";

export const useMainTheme = () => {
  const companyDetail = useRecoilValue(CompanyDetails);
  const appTheme = get(companyDetail, "theme", "CLASSIC");

  return { appTheme };
};
